import { Env } from '@didi/utils'
import { getLoginSDK } from '../core/login'

const ERR_OK = 0

function passengerIsLogin(sdk, config, callback) {
  sdk.call('getUserInfo', {}, (err, ret) => {
    if (err.errno !== ERR_OK) {
      callback && callback(err)
    } else {
      callback && callback(null, {
        phone: ret.phone,
        token: ret.token
      })
    }
  })
}

function driverIsLogin(sdk, config, callback) {
  sdk.getUserInfo((ret) => {
    if (!ret) {
      callback && callback('unknown error')
    } else {
      callback && callback(null, {
        phone: ret.phone,
        token: ret.ticket
      })
    }
  })
}

function webIsLogin(sdk, config, callback) {
  sdk.setConfig(config)

  sdk.isLogin(ret => {
    if (ret.login) {
      callback && callback(null, {
        phone: ret.cell,
        token: ret.ticket
      })
    } else {
      callback && callback('Not logged in')
    }
  })
}

export function isLogin(config, callback) {
  getLoginSDK(config)
    .then(sdk => {
      if (Env.isPassenger) {
        passengerIsLogin(sdk, config, callback)
      } else if (Env.isDriver) {
        driverIsLogin(sdk, config, callback)
      } else {
        webIsLogin(sdk, config, callback)
      }
    })
    .catch(error => {
      console.log(error)
    })
}

export default isLogin